import React from "react";
import clsx from "clsx";

import styles from "./AnimatedFigure.module.css";

export default function AnimatedFigure(props) {
  const { alt, src } = props;

  return src && src.endsWith(".gif") ? (
    <figure className="gatsby-resp-image-figure">
      <span className={clsx("gatsby-resp-image-wrapper", styles.wrapper)}>
        <img
          className={clsx("gatsby-resp-image-image", styles.image)}
          alt={alt}
          title={alt}
          src={src}
        />
      </span>
      <figcaption className="gatsby-resp-image-figcaption">{alt}</figcaption>
    </figure>
  ) : (
    <img alt={props.alt} {...props} />
  );
}
